import antdEn from 'antd/lib/locale-provider/vi_VN';
import viMessages from '../locales/vi_VN.json';
const ViLang = {
  messages: {
    ...viMessages,
  },
  antd: antdEn,
  locale: 'vi-VN',
};
export default ViLang;
